module.exports = __webpack_public_path__ + "static/media/tr-TR.d2b845f3.md";